import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {FieldDefinition} from "@shared/models/field-definition";
import {CellComponent} from "@shared/components/cell-components/cell-component";

@Component({
    standalone: false,
    selector: 'app-note-cell-viewer',
  templateUrl: './note-cell-viewer.component.html',
  styleUrls: ['./note-cell-viewer.component.scss']
})
export class NoteCellViewerComponent implements OnInit, CellComponent  {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {

  }


  openNote() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, noteKey: `${this.fieldDefinition.key}_Detail` ,action: {id: 'OpenNote'}})
  }

}
